import React, { ChangeEvent, FC, useCallback, useMemo, useState } from 'react'
import { ImageProps } from 'next/image'
import { useTranslation } from 'next-i18next'
import tw from 'tailwind-styled-components'
import { PopupFilter } from '../PopupFilter'
import { TextInput } from '../Inputs/TextInput'
import { RangeValue } from './utils'

type Props = {
  title: string
  min: RangeValue[0]
  max: RangeValue[0]
  icon?: ImageProps['src']
  onChange(value: RangeValue): void
}

const PopupInput = tw(TextInput)`min-w-[120px]`
const defaultState: RangeValue = [null, null]

export const PopupRangeFilter: FC<Props> = ({ onChange, min, max, title, icon }) => {
  const initialState = useMemo<RangeValue>(() => [min, max], [min, max])
  const { t } = useTranslation('common')
  const [value, setValue] = useState(initialState)
  const onSave = useCallback(() => onChange(value), [onChange, value])
  const onClear = useCallback(() => {
    setValue(defaultState)

    onChange(defaultState)
  }, [onChange, setValue])
  const setMinValue = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      const minValue = parseFloat(target.value)

      setValue([isNaN(minValue) ? null : minValue, value[1]])
    },
    [setValue, value]
  )
  const setMaxValue = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      const maxValue = parseFloat(target.value)

      setValue([value[0], isNaN(maxValue) ? null : maxValue])
    },
    [setValue, value]
  )

  return (
    <PopupFilter icon={icon} title={title} onSave={onSave} onClear={onClear}>
      <div className='flex space-x-4'>
        <PopupInput
          name={`${title}-min`}
          label={t('min')}
          type='number'
          defaultValue={value[0] ?? ''}
          onChange={setMinValue}
        />
        <PopupInput
          name={`${title}-max`}
          label={t('max')}
          type='number'
          defaultValue={value[1] ?? ''}
          onChange={setMaxValue}
        />
      </div>
    </PopupFilter>
  )
}
